module.exports = "<shared-org-form [org]=\"org\" (save)=\"onSave()\" #orgform [editMode]=\"false\" [register]=\"true\"></shared-org-form>\n"